import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ViewLoading from 'components/view/loading';
import NotFoundPage from 'components/pages/error/404';

import {
  Storefronts,
  mapStateToProps as sfMapStateToProps,
  mapDispatchToProps as sfMapDispatchToProps,
} from 'containers/Storefronts';
import StorefrontView from 'components/storefront/view';

export const mapStateToProps = (state) => ({
  ...sfMapStateToProps(state),
  loadingAny: state.loading,
  loading: state.storefronts.loading,
});

export const mapDispatchToProps = (dispatch) => ({
  ...sfMapDispatchToProps(dispatch),
});

export class ViewStorefront extends Storefronts {
  static contextTypes = {
    ...Storefronts.contextTypes,
    client: PropTypes.object.isRequired,
    notifySuccess: PropTypes.func.isRequired,
    notifyError: PropTypes.func.isRequired,
    notifyDeleted: PropTypes.func.isRequired,
  };

  mounted = false;

  constructor(props) {
    super(props);
    this.state = {
      ...this.state,
      loaded: false,
    };
  }

  componentDidMount() {
    const { params } = this.props;

    this.mounted = true;

    this.fetchStorefront(params.id);
  }

  componentWillReceiveProps(nextProps) {
    if (this.props.params.id !== nextProps.params.id) {
      this.setState({ loaded: false });
      this.fetchStorefront(nextProps.params.id);
    }
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  async fetchStorefront(storefrontId) {
    const { router, fetchStorefront, getInstalledApps } = this.props;

    const [storefront] = await Promise.all([fetchStorefront(storefrontId)]);

    if (!storefront) {
      router.push('/storefronts');
    }

    const { storefrontApp, themeApp } = await getInstalledApps(storefront);

    this.setState({ loaded: true, storefrontApp, themeApp });

    return storefront;
  }

  render() {
    if (!this.state.loaded) {
      return <ViewLoading />;
    }

    if (!this.props.record) {
      return <NotFoundPage />;
    }

    return <StorefrontView {...this.props} {...this.state} />;
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ViewStorefront);
